import { QueryClient } from "@tanstack/react-query";
import { client } from "@/client";

/** The signed-in areas whose routes read the profile while validating a URL -- and the magic-link landing route, which redirects into them client-side. */
export const needsAccount = (pathname: string) =>
  /^\/(dashboard|admin-dashboard|next)(\/|$)/.test(pathname);

/**
 * Loads /me before the router's first pass. The router validates a fresh URL's search, and writes
 * the result into the URL, before any route's beforeLoad or loader runs; route defaults such as a
 * table's saved page size (ID-6897) read the cached /me synchronously, so it has to be there
 * already. The /dashboard loader needs /me anyway and reuses this fetch. A failure is not handled
 * here: on 401/440 the API client's interceptor has already sent the browser to the login, with
 * the current location (path and search) as the way back; anything else is left to that loader,
 * which fetches again and redirects. No toast either way -- nothing is on screen yet.
 */
export const primeAccount = async (queryClient: QueryClient): Promise<void> => {
  try {
    await queryClient.ensureQueryData({
      ...client.users.me.asQueryOptions(),
      retry: false,
      staleTime: Infinity,
      meta: { hideToast: true },
    });
  } catch {
    // See above.
  }
};
